import type React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const ArrowBack = (props: IconProps) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.1364 8.3636C13.7849 8.01213 13.2151 8.01213 12.8636 8.3636L9.86363 11.3636C9.51216 11.7151 9.51216 12.2849 9.86363 12.6364L12.8636 15.6364C13.2151 15.9879 13.7849 15.9879 14.1364 15.6364C14.4879 15.2849 14.4879 14.7151 14.1364 14.3636L11.7728 12L14.1364 9.63639C14.4879 9.28492 14.4879 8.71507 14.1364 8.3636Z"
		/>
	</svg>
);
